import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { useState } from 'react';
import { useUploadFiles } from 'src/hooks/useUploadFiles';
import { ProductFile } from 'src/pages/UploadPage/Uploader';

export function useUpload(presignedURLQuery: any) {
  const [uploadedCadFile, setUploadedCadFile] = useState<ProductFile[]>([]);
  const [runID, setRunID] = useState<string>('');

  const mutation: UseMutationResult<unknown, unknown, string, unknown> = useMutation(
    ['uploadFiles'],
    presignedURLQuery
  );

  const { mutate, filesUploadStatus, controller, isLoading, isError, isSuccess } = useUploadFiles(uploadedCadFile);

  const uploadFile = () => {
    mutate();
  };

  const handleCancelUpload = () => {
    setUploadedCadFile([]);
    setRunID('');
    controller.abort();
  };

  const newUploadStatuses = [...filesUploadStatus.entries()].filter(([fileName]) =>
    uploadedCadFile.some((file) => file.file.name === fileName)
  );

  const isUploadComplete =
    filesUploadStatus.size > 0 && // Check if all files in filesUploadStatus have been successfully uploaded
    Array.from(filesUploadStatus.values()).every((status) => status.isSuccess);

  return {
    isLoading,
    runID,
    mutation,
    uploadFile,
    handleCancelUpload,
    newUploadStatuses,
    isUploadComplete,
    setRunID,
    setUploadedCadFile,
    isError,
    isSuccess,
  };
}
